import 'moment/locale/ru'
import moment from 'moment'

export default {
  Сегодня: [moment(), moment(), 'today'],
  Вчера: [moment().subtract(1, 'days'), moment().subtract(1, 'days'), 'yesterday'],
  'Последние 7 дней': [moment().subtract(6, 'days'), moment(), 'last_7_days'],
  'Последние 30 дней': [moment().subtract(29, 'days'), moment(), 'last_30_days'],
  'Текущий месяц': [moment().startOf('month'), moment().endOf('month'), 'current_month'],
  'Прошлый месяц': [
    moment()
      .subtract(1, 'month')
      .startOf('month'),
    moment()
      .subtract(1, 'month')
      .endOf('month'),
    'prev_month'
  ]
}
